import React from "react";

interface Props {
  onCancel: () => void;
}

const CreateCategoryLayout: React.FC<Props> = ({ onCancel }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-4 lg:p-0">
      {/* Left: Bulk upload */}
      <div className="bg-white rounded-2xl border border-[#D6CCF7] p-6 lg:p-8 shadow-sm flex flex-col">
        <h2 className="text-xl font-bold text-[#402B69] mb-6 flex items-center gap-2">
          Add Bulk Category
        </h2>
        <div className="flex-1 bg-purple-50/50 border-2 border-dashed border-[#D6CCF7] rounded-2xl p-8 flex flex-col items-center justify-center min-h-[200px] mb-6 transition-colors hover:bg-purple-50">
          <p className="text-[#885ABB] text-lg font-bold text-center">
            Upload a CSV file
          </p>
          <p className="text-sm text-[#885ABB]/60 mt-2">Maximum file size 5MB</p>
        </div>
        <button className="w-full lg:w-auto px-8 py-3 bg-[#885ABB] hover:bg-[#6f47a2] text-white rounded-xl font-bold shadow-md transition-all transform hover:-translate-y-0.5">
          Upload CSV
        </button>
      </div>

      {/* Right: Manual form */}
      <div className="bg-white rounded-2xl border border-[#D6CCF7] p-6 lg:p-8 shadow-sm">
        <h2 className="text-xl font-bold text-[#402B69] mb-6">
          Add Category Manually
        </h2>
        <div className="space-y-6">
          <div className="space-y-2">
            <label className="block text-sm font-bold text-[#402B69]">
              Category Name
            </label>
            <input
              type="text"
              placeholder="e.g. Skin Care"
              className="w-full border border-[#BBB9F3] rounded-xl px-4 py-3 bg-[#F9F9F9] focus:ring-2 focus:ring-[#885ABB]/40 focus:border-[#885ABB] outline-none transition-all"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-bold text-[#402B69]">
              Category Slug
            </label>
            <input
              type="text"
              placeholder="e.g. skin-care"
              className="w-full border border-[#BBB9F3] rounded-xl px-4 py-3 bg-[#F9F9F9] focus:ring-2 focus:ring-[#885ABB]/40 focus:border-[#885ABB] outline-none transition-all"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-bold text-[#402B69]">
              Category Image
            </label>
            <div className="bg-purple-50/50 border-2 border-dashed border-[#D6CCF7] rounded-2xl p-8 flex flex-col items-center justify-center min-h-[160px] transition-colors hover:bg-purple-50">
              <p className="text-[#885ABB] font-bold">Drag and drop image here</p>
              <p className="text-xs text-[#885ABB]/60 mt-1">or click to browse</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 pt-4">
            <button className="flex-1 px-8 py-3 bg-[#885ABB] hover:bg-[#6f47a2] text-white rounded-xl font-bold shadow-md transition-all transform hover:-translate-y-0.5">
              Save Category
            </button>
            <button
              onClick={onCancel}
              className="flex-1 px-8 py-3 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-xl font-bold transition-all"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCategoryLayout;
